import { render, staticRenderFns } from "./createPPOBProduct.vue?vue&type=template&id=fe917162&scoped=true&"
import script from "./createPPOBProduct.vue?vue&type=script&lang=js&"
export * from "./createPPOBProduct.vue?vue&type=script&lang=js&"
import style0 from "./createPPOBProduct.vue?vue&type=style&index=0&id=fe917162&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe917162",
  null
  
)

export default component.exports